import { ISubstanceByStoreDTO, ISubstanceDTO, ISubstanceViewDTO } from "../../libs/coreapi-dto/dirs/substance";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class SubstanceDataProvider extends DictionaryDataProvider<ISubstanceViewDTO, ISubstanceDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ISubstanceViewDTO, ISubstanceDTO>> {
        return this._coreApiService.substanceRequest
    }

    getDistinctViewByStore(filter: IViewBody, callback?: (data: ISubstanceByStoreDTO[], totalCount: number,) => void, signal?: AbortSignal | null) {
            this._coreApiService.substanceRequest
                .then(r => r
                    .getDistinctViewByStore(filter, (e) => {
                        if (e.respType === 'isCompleted') {
                            try {
                                callback?.(e.data.entities, e.data.totalCount);
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        else
                            throw new Error(e?.message.title ?? 'DictionaryDataProvider getDistinctViewByStore !isCompleted');
                    },signal)
                )
                .catch((e) => {
                    throw new Error(e?.message.text ?? 'getDistinctViewByStore DictionaryDataProvider')
                });
        }
}